// extracted by mini-css-extract-plugin
module.exports = {"multiContent":"_54adc30"};